import React from 'react';
import { Container } from 'reactstrap';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import KS from '../services/KensoftApi';
import './Tdsbanner.css';
import parse from 'html-react-parser'
class Tdsbanner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sliders:[],
            responsive: {
                0: {
                    nav: false,
                    dots: true,
                },
                767: {
                    nav: true
                },

            },
        }

    }
    componentDidMount() {
        KS.getSlider({
            id: "10035",
            langid:1
        }).then((data) => {
  
            if ((data || {}).Success) {
                this.setState({ sliders: data.Slider });
            }
            else {
            }
        })
    }

    render() {
        return (

            <section className="banner">

                <OwlCarousel
                    className="banner-owl owl-theme"
                    loop={true}
                    margin={0}
                    autoplay={true}
                    autoplayTimeout={3000}
                    smartSpeed={500}
                    nav={true}
                    items="1"
                    responsive={this.state.responsive}
                    dots={false} >
                    {this.state.sliders.map((item) => {
                        let ItemImage = "http://riyadhgrp.com/" + item.FullImagePath + ".jpg";
                        return (
                            <div className="item">
                                <div className="banner-one banner-img" style={{ backgroundImage: `url(${ItemImage})` }}>
                                    <Container>
                                        <div className="banner-text text-center">
                                            <h1 >{parse(item.Description)}</h1>
                                            <p>{parse(item.ShortDescription)}</p>                                            <div className="d-flex justify-content-center">

                                            </div>

                                        </div>
                                    </Container>
                                </div>
                            </div>
                            )
                    })}
                   
                </OwlCarousel>
            </section>
        );
    }
}


export default Tdsbanner;
